import { graphql } from '@contra/relay';

export const AuthenticateUser = graphql`
  mutation AuthenticateUserMutation($input: ConfirmShortCodeInput!) {
    confirmShortCode(input: $input) {
      errors {
        __typename
        message
      }
      result
      visitor {
        id
        userAccount {
          id
          emailAddress
          profile {
            displayUsername
          }
        }
        ...AppPreload_visitor
      }
    }
  }
`;
